export const GET_BLOODDONATIONS = "GET_BLOODDONATIONS";
export const FILTER_BLOODDONATIONS = "FILTER_BLOODDONATIONS";
export const ADD_BLOODDONATION = "ADD_BLOODDONATION";
export const EDIT_BLOODDONATION = "EDIT_BLOODDONATION";
export const GET_BLOODDONATION = "GET_BLOODDONATION";
export const RESET_BLOODDONATION = "RESET_BLOODDONATION";
export const BLOODDONATIONS_ERROR = "BLOODDONATIONS_ERROR";
